import { Icon, Spinner } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDropdownAutoClose } from '~/hooks/use-dropdown-auto-close/useDropdownAutoClose';
import { UploadAlert } from '~/views/alfred/research/upload-alert/UploadAlert';
import { useUserUpload } from '~/views/alfred/research/use-user-upload/useUserUpload';

import { SingleFile } from './SingleFile';
import * as S from './UploadFileStatusDropdown.styles';

export const UploadFileStatusDropdown = () => {
  const { t } = useTranslation(['chat']);

  const { files, removeAllFiles } = useUserUpload(state => ({
    files: state.files,
    removeAllFiles: state.removeAllFiles,
  }));

  const { dropdownOpen, setDropdownOpen } = useDropdownAutoClose();

  const isUploading = files.some(file => file.status === 'uploading');
  const completeCount = files.filter(file => file.status === 'complete').length;

  const pillLabel = (() => {
    if (isUploading) {
      return t('chat:userUpload.uploading');
    }

    if (completeCount) {
      return t('chat:userUpload.attachmentsWithCount', {
        count: completeCount,
      });
    }

    return '';
  })();

  return (
    <>
      {pillLabel && !!files.length && (
        <S.StyledDropdownMenu
          open={dropdownOpen}
          onOpenChange={setDropdownOpen}
          triggerNode={
            <div>
              <S.StyledButton variant="tertiary" size="small">
                <S.InfoWrapper>
                  {isUploading ? (
                    <Spinner size="small" />
                  ) : (
                    <Icon iconName="Paperclip" size={12} />
                  )}
                  {pillLabel && <S.PillLabel>{pillLabel}</S.PillLabel>}
                </S.InfoWrapper>
                {!!completeCount && (
                  <Icon
                    iconName="Close"
                    onPointerDown={removeAllFiles}
                    size={12}
                  />
                )}
              </S.StyledButton>
            </div>
          }
        >
          {files.map(i => (
            <div key={i.field_name}>
              <SingleFile {...i} />
            </div>
          ))}
        </S.StyledDropdownMenu>
      )}
      <UploadAlert onViewDetails={() => setDropdownOpen(true)} />
    </>
  );
};
